/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { persistentState } from 'common/utils/types/helpers'
import packageInfo from '../../../package.json'

interface XHRProps {
  url: string
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  parameters?: any
  data?: any
}

export default function xhr({ url, method, parameters, data }: XHRProps) {
  const deviceCode = persistentState.device.getRaw('deviceCode')

  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      // if (error.response.status > 400)
      //  window.location.href = '/#/signin/teacher';
      return Promise.reject(error)
    }
  )

  return axios({
    url,
    method,
    data: {
      client: {
        device: deviceCode,
        code: deviceCode,
        locale: 'en',
        target: 'web',
        version: packageInfo.version,
      },
      ...data,
    },
    params: parameters,
  })
}
